import React, { useState } from "react";
import ContactUs from "../../Templates/Common/ContactUs";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import Card from "../../Components/Card";
import { useEffect } from "react";
import SearchSection from "../../Templates/HeroPage/SearchSection";
import OfferSection from "../../Templates/HeroPage/OfferSection";
import GenreSection from "../../Templates/HeroPage/GenreSection";
import PSLImage from "../../assets/Psl.png";
import "./style.css";
import { Link } from "react-router-dom";
function HeroPage() {
  const [active, setActive] = useState(2);
  useEffect(() => {
  }, [active]);
  return (
    <>
      <SearchSection />
      <OfferSection />

      <div className="bg-[#FFF6F8]">
        <GenreSection />
        <div>
          <p className="text-center font-bold text-3xl pt-20">
            Top Media Properties
          </p>
        </div>
        <div className="h-[300px]  ">
          <Swiper
            slidesPerView={1}
            initialSlide={1}
            centeredSlides={true}
            spaceBetween={10}
            grabCursor={true}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              768: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
            }}
            modules={[Pagination]}
            className="mySwiper"
            onSlideChange={(index) => setActive(index.activeIndex)}
          >
            {[["Facebook, App","Mask Group 2"], ["Youtube, App","Mask Group 3"], ["Jio Saavan, App","Mask Group 1"]].map((v, k) => (
              <SwiperSlide key={k} style={{ background: "#FFF6F8" }}>
                <Link to="/digital">
                  <Card style={active === k ? "h-48 " : ""} imgLink={require(`../../assets/${v[1]}.png`)}  text={v[0]} />
                  </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="h-[700px]  ">
          <Swiper className="">
            <SwiperSlide>
              {" "}
              <div className=" backgroundpsl ">
                <div className="backdrop lg:px-36 px-10 py-20 ">
                  <div className="grid lg:grid-cols-2 grid-cols-1">
                    <div>
                      <p className="text-white text-4xl font-bold pb-2">
                        HBL - Pakistan Super League{" "}
                      </p>
                      <p className="text-white">2030 | Karachi</p>
                      <p className="text-white pt-10 text-gray-300">
                        Qui soluta quis libero laudantium facilis. Eum mollitia
                        culpa. Aut inventore rerum itaque quisquam repellat.
                        Reiciendis fuga totam quo ut. Quibusdam ut eligendi eius
                        est nulla consequatur porro sed enim. Qui soluta quis
                        libero laudantium facilis. Eum mollitia culpa. Aut
                        inventore rerum itaque quisquam repellat. Reiciendis
                        fuga totam quo ut. Quibusdam ut eligendi eius est nulla
                        consequatur porro sed enim .Qui soluta quis libero
                        laudantium facilis. Eum mollitia culpa. Aut inventore
                        rerum itaque quisquam repellat. Reiciendis fuga totam
                        quo ut. Quibusdam ut eligendi eius est nulla consequatur
                        porro sed enim.
                      </p>
                      <button className="mt-5 text-white bg-primary py-2 px-7 rounded-full">
                        {" "}
                        Learn More
                      </button>
                      <img src={PSLImage} className="mt-24" alt="t" />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              {" "}
              <div className=" backgroundpsl ">
                <div className="backdrop lg:px-36 px-10 py-20 ">
                  <div className="grid lg:grid-cols-2 grid-cols-1 ">
                    <div>
                      <p className="text-white text-4xl font-bold pb-2">
                        HBL - Pakistan Super League{" "}
                      </p>
                      <p className="text-white">2022 | Karachi</p>
                      <p className="text-white pt-10 text-gray-300">
                        Qui soluta quis libero laudantium facilis. Eum mollitia
                        culpa. Aut inventore rerum itaque quisquam repellat.
                        Reiciendis fuga totam quo ut. Quibusdam ut eligendi eius
                        est nulla consequatur porro sed enim. Qui soluta quis
                        libero laudantium facilis. Eum mollitia culpa. Aut
                        inventore rerum itaque quisquam repellat. Reiciendis
                        fuga totam quo ut. Quibusdam ut eligendi eius est nulla
                        consequatur porro sed enim .Qui soluta quis libero
                        laudantium facilis. Eum mollitia culpa. Aut inventore
                        rerum itaque quisquam repellat. Reiciendis fuga totam
                        quo ut. Quibusdam ut eligendi eius est nulla consequatur
                        porro sed enim.
                      </p>
                      <button className="mt-5 text-white bg-primary py-2 px-7 rounded-full">
                        {" "}
                        Learn More
                      </button>
                      <img src={PSLImage} className="mt-24" alt="t"/>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              {" "}
              <div className=" backgroundpsl ">
                <div className="backdrop lg:px-36 px-10 py-20 ">
                  <div className="grid lg:grid-cols-2 grid-cols-1">
                    <div>
                      <p className="text-white text-4xl font-bold pb-2">
                        HBL - Pakistan Super League{" "}
                      </p>
                      <p className="text-white">2019 | Karachi</p>
                      <p className="text-white pt-10 text-gray-300">
                        Qui soluta quis libero laudantium facilis. Eum mollitia
                        culpa. Aut inventore rerum itaque quisquam repellat.
                        Reiciendis fuga totam quo ut. Quibusdam ut eligendi eius
                        est nulla consequatur porro sed enim. Qui soluta quis
                        libero laudantium facilis. Eum mollitia culpa. Aut
                        inventore rerum itaque quisquam repellat. Reiciendis
                        fuga totam quo ut. Quibusdam ut eligendi eius est nulla
                        consequatur porro sed enim .Qui soluta quis libero
                        laudantium facilis. Eum mollitia culpa. Aut inventore
                        rerum itaque quisquam repellat. Reiciendis fuga totam
                        quo ut. Quibusdam ut eligendi eius est nulla consequatur
                        porro sed enim.
                      </p>
                      <button className="mt-5 text-white bg-primary py-2 px-7 rounded-full">
                        {" "}
                        Learn More
                      </button>
                      <img src={PSLImage} className="mt-24" alt="t"/>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
     
      <ContactUs />
    </>
  );
}

export default HeroPage;
